import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import './styles/shared.css'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Portfolio from './components/Portfolio'
import Services from './components/Services'
import Contact from './components/Contact'
import Footer from './components/Footer'
import BackToTop from './components/BackToTop'
import Process from './components/Process'
import ErrorBoundary from './components/ErrorBoundary'
import LoadingSpinner from './components/LoadingSpinner'
import PrivacyPolicy from './components/PrivacyPolicy'
import TermsOfService from './components/TermsOfService'
import CookieConsent from './components/CookieConsent'

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => setIsLoading(false), 450)

    return () => clearTimeout(timer)
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const HomePage = () => (
    <div className="app">
      <Navbar />
      <Hero />
      <About />
      <Portfolio />
      <Process />
      <Services />
      <Contact />
      <Footer />
      <BackToTop />
    </div>
  );

  return (
    <ErrorBoundary>
      <Router>
        <CookieConsent />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  )
}

export default App
